import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';
import {
    Container,
    Box,
    Typography,
    Paper,
    Button,
} from '@mui/material';
import logo from '../assets/LOGO.png';
import { loginData } from '../services/AdminServices';
// import { v4 as uuidv4 } from 'uuid';

const paperStyles = {
    width: '100%',
    height: '45%',
    minHeight: '230px',
    padding: 4,
    borderRadius: 3,
    boxShadow: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    backgroundColor: '#fff',
};

const Login = () => {
   
    const navigate = useNavigate();

    const handleGoogleLoginSuccess = async (tokenResponse) => {
        try {
            // const deviceId = uuidv4();
            const decoded = jwtDecode(tokenResponse.credential);
            const response = await loginData(decoded.email, tokenResponse.credential);
            if (response?.data?.data) {
                localStorage.setItem("user", JSON.stringify(response.data.data))
                localStorage.setItem('token', response.data.data.token);
                toast.success(response.data.message);
                const attendancePath=JSON.parse(localStorage.getItem("attendancePath"))
                const practicePath=localStorage.getItem('practicePath')
                if (attendancePath) {
                    setTimeout(() => navigate(attendancePath?.attendancePath), 1000);
                }
                else if (practicePath) {
                    setTimeout(() => navigate(practicePath), 1000);
                } 
                else {
                    setTimeout(() => navigate('/learner/attendance'), 1000);
                }
            } else {
                throw new Error('Invalid response from server.');
            }
        } catch (error) {
            toast.error(error.response?.data?.message || 'Something went wrong. Please try again.');
        }
    };

    const handleGoogleLoginFailure = () => {
        toast.error('Google login failed. Please try again.');
    };

    return (
        <Container
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                width: {xs:"auto",sm:'38vw'},
                padding: 2,
            }}
        >
            <Paper sx={paperStyles}>
                <Box sx={{ textAlign: 'center', mb: 2 }}>
                    <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', mb: 1 }}>
                        <img src={logo} alt="Logo" />
                    </Typography>
                    <Typography
                        variant="h4"
                        component="h1"
                        sx={{ fontWeight: 'bold', color: '#3f51b5', letterSpacing: 1.5 }}
                    >
                        Welcome Back!
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    sx={{
                        // width: '50%',
                        height: '60px',
                        fontSize: '16px',
                        fontWeight: '500',
                        textTransform: 'none',
                        borderRadius: '5px',
                        color: '#fff',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#1976d2',
                        '&:focus': {
                            boxShadow: '0 0 3px 1px rgba(66, 133, 244, 0.5)',
                        },
                    }}
                >
                    <GoogleLogin
                        onSuccess={handleGoogleLoginSuccess}
                        onError={handleGoogleLoginFailure}
                        useOneTap
                        use_fedcm_for_prompt={false}
                        text="signin_with"
                    />
                </Button>
            </Paper>
        </Container>
    );
};

export default Login;
